import { addCustomer, editCustomer } from "../Actions/CustomerManagementAction";

export const REQUIRED_FIELDS = [
  "firstName",
  "lastName",
  "emailAddress",
  "phoneNumber",
  "alternatePhoneNumber",
  "billingAddress",
];

export const FIELD_LABELS = {
  firstName: "First Name",
  lastName: "Last Name",
  emailAddress: "Email Address",
  phoneNumber: "Phone Number",
  alternatePhoneNumber: "Alternate Phone Number",
  billingAddress: "Billing Address",
};

export const validateCustomerForm = (formData) => {
  let isValid = true;
  const errors = {};

  REQUIRED_FIELDS.forEach((field) => {
    const value = formData[field];
    if (!value || value.trim() === "") {
      isValid = false;
      errors[field] = `Please enter ${FIELD_LABELS[field] || field}`;
    }
  });

  if (formData.emailAddress) {
    const emailRegex = /^[\w.-]+@[\w.-]+\.\w{2,4}$/;
    if (!emailRegex.test(formData.emailAddress)) {
      isValid = false;
      errors.emailAddress = "Please enter a valid Email Address";
    }
  }

  ["phoneNumber", "alternatePhoneNumber"].forEach((field) => {
    const value = formData[field];
    if (value && !/^\d{10}$/.test(value)) {
      isValid = false;
      errors[field] = `Please enter a valid 10-digit ${FIELD_LABELS[field] || field}`;
    }
  });

  if (
    formData.phoneNumber &&
    formData.alternatePhoneNumber &&
    formData.phoneNumber === formData.alternatePhoneNumber
  ) {
    isValid = false;
    errors.alternatePhoneNumber = "Alternate Number must be different";
  }

  return { isValid, errors };
};

export const buildCustomerPayload = (formData) => ({
  firstName: formData.firstName,
  lastName: formData.lastName,
  email: formData.emailAddress,
  phoneNumber: formData.phoneNumber,
  alternateNumber: formData.alternatePhoneNumber,
  address: formData.billingAddress,
});

export const handleAddCustomer = async (e, formData, dispatch, setFormError) => {
  e.preventDefault();
  const payload = buildCustomerPayload(formData);
  try {
    await dispatch(addCustomer(payload));
  } catch {
    setFormError("An error occurred while adding the customer.");
  }
};

export const handleEditCustomer = async (
  e,
  formData,
  editData,
  dispatch,
  setFormError
) => {
  e.preventDefault();
  const payload = buildCustomerPayload(formData);
  try {
    await dispatch(editCustomer(editData.customerId, payload));
  } catch {
    setFormError("An error occurred while updating the customer.");
  }
};

export const populateEditData = (editData) => {
  const fullName = editData.customerName?.trim() || "";
  const [firstName, ...lastNameParts] = fullName.split(" ");
  const lastName = lastNameParts.join(" ");
  return {
    firstName,
    lastName,
    emailAddress: editData.emailaddress,
    phoneNumber: editData.phoneNumber,
    alternatePhoneNumber: editData.alternateNumber,
    billingAddress: editData.billingAddress,
  };
};

export const getEmptyCustomerForm = () => ({
  firstName: "",
  lastName: "",
  emailAddress: "",
  phoneNumber: "",
  alternatePhoneNumber: "",
  billingAddress: "",
});
